import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import InvoiceFormWizard from './Invoices/components/InvoiceFormWizard';

export default function EstimateFormPage() {
  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <InvoiceFormWizard
      isOpen={true}
      onClose={() => navigate(id ? `/estimates/${id}` : '/estimates')}
      onSuccess={() => navigate('/estimates?refresh=true')}
      estimateId={id}
      mode="estimate"
    />
  );
}
